import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import baseUrl from "../../API/BaseUrl";

const initialState = {
  AllCategories: [],
  AddCategory: [],
  OneCategory: [],
  editOneCategory: [],
  deleteCategory: [],
  isLoading: true,
  isSuccess: false,
  errorMessage: "",
};


// create new category
export const CreateNewCategory = createAsyncThunk(
  "createCategory",
  async (formData) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
      }
      const newCategory = await baseUrl.post("/api/v1/categories", formData, config);
      return newCategory;
    } catch (error) {
      return error;
    }
  }
);


// Get All Categories
export const GetAllCategories = createAsyncThunk(
  "categories/getAll",
  async (querySelector) => {
    try {
      const res = await baseUrl.get(`/api/v1/categories?${querySelector}`);
      return res.data;
    } catch (error) {
      return error;
    }
  }
);


// delete Category
export const DeleteOneCategory = createAsyncThunk(
  "categories/deleteOne",
  async (id) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
      }
      const res = await baseUrl.delete(`/api/v1/categories/${id}`, config);
      return res.data;
    } catch (error) {
      return error;
    }
  }
);



// get one category
export const getOneCategory = createAsyncThunk(
  "getOneCategory",
  async (CatId) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
      }
      const res = await baseUrl.get(`/api/v1/categories/${CatId}`, config);
      return res;
    } catch (error) {
      return error;
    }
  }
);


// edit category
export const editCategory = createAsyncThunk(
  "editCategory",
  async ({ id, formData }) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
      }
      const res = await baseUrl.put(`/api/v1/categories/${id}`, formData, config);
      return res;
    } catch (error) {
      return error;
    }
  }
);



const CategorySlice = createSlice({
  name: "Category",
  initialState: initialState,
  reducers: {},
  extraReducers: {
    [GetAllCategories.pending]: (state, action) => {
      state.isLoading = true;
    },
    [GetAllCategories.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.AllCategories = action.payload;
    },
    [GetAllCategories.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.errorMessage = action.payload;
    },
    [CreateNewCategory.pending]: (state, action) => {
      state.isLoading = true;
    },
    [CreateNewCategory.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.AddCategory = action.payload;
    },
    [CreateNewCategory.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [getOneCategory.pending]: (state, action) => {
      state.isLoading = true;
    },
    [getOneCategory.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.OneCategory = action.payload;
    },
    [getOneCategory.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [DeleteOneCategory.pending]: (state, action) => {
      state.isLoading = true;
    },
    [DeleteOneCategory.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.deleteCategory = action.payload;
    },
    [DeleteOneCategory.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [editCategory.pending]: (state, action) => {
      state.isLoading = true;
    },
    [editCategory.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.editOneCategory = action.payload;
    },
    [editCategory.rejected]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
  },
});

export default CategorySlice.reducer;
